import axios from 'axios'
import {setupAxios} from '../app/modules/auth'
import {API_BASE_URL} from '../utils/contants'

const API_WORKING_SHIFT = 'working-shift-master'

export const getWorkingShifts = async (activeOnly: boolean = true) => {
  const {token} = setupAxios()
  try {
    const query = activeOnly ? '?active=true' : ''
    const response = await axios.get(`${API_BASE_URL}/${API_WORKING_SHIFT}${query}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching working shifts:', error)
    throw error
  }
}

export const getWorkingShift = async (id: string) => {
  const {token} = setupAxios()
  try {
    const response = await axios.get(`${API_BASE_URL}/${API_WORKING_SHIFT}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching working shift:', error)
    throw error
  }
}

export const createWorkingShift = async (data: {
  shiftName: string
  startTime: string
  endTime: string
  isActive?: boolean
}) => {
  const {token} = setupAxios()
  try {
    const response = await axios.post(`${API_BASE_URL}/${API_WORKING_SHIFT}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error('Error creating working shift:', error)
    throw error
  }
}

export const updateWorkingShift = async (
  id: string,
  data: {
    shiftName?: string
    startTime?: string
    endTime?: string
    isActive?: boolean
  }
) => {
  const {token} = setupAxios()
  try {
    const response = await axios.put(`${API_BASE_URL}/${API_WORKING_SHIFT}/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error('Error updating working shift:', error)
    throw error
  }
}

export const deleteWorkingShift = async (id: string) => {
  const {token} = setupAxios()
  try {
    const response = await axios.delete(`${API_BASE_URL}/${API_WORKING_SHIFT}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error('Error deleting working shift:', error)
    throw error
  }
}

export const toggleWorkingShiftActive = async (id: string) => {
  const {token} = setupAxios()
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/${API_WORKING_SHIFT}/${id}/toggle-active`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error toggling working shift status:', error)
    throw error
  }
}